import { useCallback } from 'react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import type { DialogProps } from '@/dialogs/types'

interface Props extends DialogProps {
  onDelete: () => void
}

export const DeleteFanSpendColorDialog = ({
  isOpen,
  onClose,
  onDelete,
}: Props) => {
  const handleSubmit = useCallback(() => {
    onDelete()
    onClose()
  }, [onClose, onDelete])

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Delete Creator</Dialog.Title>
        <Dialog.Description className="text-center">
          Are you sure you want to delete this color?
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.Footer className="mt-6">
        <Button
          variant="outline"
          onClick={onClose}
          className="w-full"
        >
          Cancel
        </Button>
        <Button
          variant="destructive"
          onClick={handleSubmit}
          className="w-full"
        >
          Delete
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
